class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;
    
    async function animationRandom() {
        console.log("Quay");
        fly();

        setTimeout(() => {
            stopAndReset();
        }, 2200);
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 2100,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            animationRandom();
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
            // globalCount = 10;

        },
    })

    const btn = document.getElementById('speedBtn');
    const statusText = document.getElementById('status');
    let multiplier = 4;
    let animationId; // Dùng để lưu ID của requestAnimationFrame để có thể dừng

    const birds = [
    { root: 'root-1', img: 'img-1', flap: 'flap-1', pos: 0, dir: -1, range: 1000 },
    { root: 'root-2', img: 'img-2', flap: 'flap-2', pos: 0, dir: 1,  range: 1000 }
    ];

    function fly() {
        birds.forEach(b => {
            const rootEl = document.getElementById(b.root);
            const imgEl = document.getElementById(b.img);
            const flapEl = document.getElementById(b.flap);

            // Add class vào div cha của .bird-img để chạy hiệu ứng vỗ cánh
            if (flapEl) {
                flapEl.classList.add('flapper');
                flapEl.classList.remove('stop-animation');
            }
        
            b.pos += b.dir * 1.5 * multiplier;
        
            if (Math.abs(b.pos) >= b.range) {
              b.dir *= -1;
            }
        
            // Lật hình chuẩn theo hướng bay
            imgEl.style.transform = b.dir > 0 ? "scaleX(1)" : "scaleX(-1)";
        
            const y = Math.sin(b.pos * 0.05) * 15;
            rootEl.style.transform = `translateX(${b.pos}px) translateY(${y}px)`;
          });
        
          animationId = requestAnimationFrame(fly);
    }
    function stopAndReset() {
        // 1. Dừng vòng lặp requestAnimationFrame
        cancelAnimationFrame(animationId);
      
        birds.forEach(b => {
          const rootEl = document.getElementById(b.root);
          const imgEl = document.getElementById(b.img);
          const flapEl = document.getElementById(b.flap);
      
          // 2. Đưa tọa độ về 0 (vị trí ban đầu)
          b.pos = 0;
          rootEl.style.transform = `translateX(0px) translateY(0px)`;
          
          // 3. Đưa hình ảnh về hướng mặc định (ví dụ scaleX(1))
          imgEl.style.transform = "scaleX(1)";
      
          // 4. Dừng hiệu ứng vỗ cánh (CSS Animation)
          flapEl.classList.add('stop-animation');
          flapEl.classList.remove('flapper');
        });
      
        //statusText.innerText = "Trạng thái: Đã dừng và Reset!";
      }

    
});
